'use client';

import { useState } from 'react';
import { useSearchParams } from 'next/navigation';

import { BlockClassyFragment } from '~/server/generated/contentful-graphql';

import { LoadingStar } from './loading-star';

export function ClassyIframe({
  block,
  amount,
  utmCampaign,
  utmMedium,
}: {
  block: Pick<BlockClassyFragment, 'campaignId' | 'headline' | 'recurringNudges'>;
  amount?: number;
  utmCampaign?: string;
  utmMedium?: string;
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const searchParams = useSearchParams();

  // Use provided props first, then fall back to URL search params, then defaults
  const cSrc = utmMedium || searchParams.get('utm_medium') || 'web';
  const cSrc2 = utmCampaign || searchParams.get('utm_campaign') || 'homepage';

  const src = `https://donate.starlight.org/give/${block.campaignId}#!/donation/checkout?eg=true${
    block.recurringNudges ? '&egrn=true' : ''
  }&c_src=${cSrc}&c_src2=${cSrc2}${amount ? `&amount=${amount}` : ''}`;

  return (
    <div className='relative mx-auto max-w-[384px] overflow-hidden rounded-2xl px-4 md:pb-4 lg:w-full lg:max-w-[480px] lg:bg-white [&_iframe]:h-[520px] xl:[&_iframe]:h-[600px]'>
      {!isLoaded && (
        <div className='absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-white'>
          <div className='size-16'>
            <LoadingStar />
          </div>
        </div>
      )}
      <iframe
        // @ts-ignore
        allowpaymentrequest='true'
        className={`w-full rounded-2xl transition-opacity duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
        height='600'
        scrolling='no'
        src={src}
        title={block.headline || 'Make a Donation'}
        loading='lazy'
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
}
